export enum AuthProvider {
  TOWNSQ = 'TOWNSQ',
  FACEBOOK = 'FACEBOOK',
  ACTIVE_DIRECTORY = 'ACTIVE_DIRECTORY',
}
